module.exports = __webpack_public_path__ + "img/exercise-small.9ef16ba3.jpg";